import { QueryClientProvider } from "@tanstack/react-query";

export const SprintQueryClientProvider = QueryClientProvider;
